import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AppMenu } from './AppMenu';
import { BottomNav } from './BottomNav';
import { MenuIcon, XIcon } from 'lucide-react';
interface LayoutProps {
  children: React.ReactNode;
}
export const Layout: React.FC<LayoutProps> = ({
  children
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showImpressum, setShowImpressum] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const toggleImpressum = () => {
    setShowImpressum(!showImpressum);
  };
  const closeImpressum = () => {
    setShowImpressum(false);
  };
  return <div className="flex flex-col min-h-screen w-full bg-gray-100" data-id="element-29">
      {/* Main content */}
      <div className="flex-1 w-full p-2 sm:p-4 pb-32 sm:pb-28" data-id="element-30">
        {showImpressum ? <div className="bg-white p-4 sm:p-6 rounded-lg max-w-3xl mx-auto my-4" data-id="element-31">
            <button onClick={toggleImpressum} className="mb-4 text-blue-600 hover:underline flex items-center" data-id="element-32">
              ← Zurück
            </button>
            <h1 className="text-2xl font-bold mb-4" data-id="element-33">Impressum</h1>
            <h2 className="text-xl font-semibold mt-4 mb-2" data-id="element-34">
              Angaben gemäß § 5 TMG
            </h2>
            <p data-id="element-35">
              INTIGOO! GmbH
              <br data-id="element-36" />
              Werner-von-Siemens-Straße 33
              <br data-id="element-37" />
              49124 Georgsmarienhütte
            </p>
            <p className="mt-2" data-id="element-38">
              Handelsregister: HRB 217224
              <br data-id="element-39" />
              Registergericht: Amtsgericht Osnabrück
            </p>
            <p className="mt-2" data-id="element-40">
              Vertreten durch:
              <br data-id="element-41" />
              Fabian Kleine Huxel
              <br data-id="element-42" />
              Felix Höfelmeyer
            </p>
            <h2 className="text-xl font-semibold mt-4 mb-2" data-id="element-43">Kontakt</h2>
            <p data-id="element-44">
              Telefon: +49 5401 1689580
              <br data-id="element-45" />
              E‑Mail: info@intigoo.de
            </p>
            <h2 className="text-xl font-semibold mt-4 mb-2" data-id="element-46">Umsatzsteuer-ID</h2>
            <p data-id="element-47">
              Umsatzsteuer-Identifikationsnummer gemäß § 27 a
              Umsatzsteuergesetz:
              <br data-id="element-48" />
              DE 349819653
            </p>
            <h2 className="text-xl font-semibold mt-4 mb-2" data-id="element-49">
              EU-Streitschlichtung
            </h2>
            <p data-id="element-50">
              Die Europäische Kommission stellt eine Plattform zur
              Online-Streitbeilegung (OS) bereit:{' '}
              <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline" data-id="element-51">
                https://ec.europa.eu/consumers/odr/
              </a>
              . Unsere E‑Mail-Adresse finden Sie oben im Impressum.
            </p>
            <h2 className="text-xl font-semibold mt-4 mb-2" data-id="element-52">
              Verbraucherstreitbeilegung / Universalschlichtungsstelle
            </h2>
            <p data-id="element-53">
              Wir sind nicht bereit oder verpflichtet, an
              Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
              teilzunehmen.
            </p>
          </div> : children}
      </div>
      {/* Bottom Navigation */}
      <BottomNav closeImpressum={closeImpressum} data-id="element-54" />
      {/* Overlay to close menu when clicked outside */}
      {isMenuOpen && <div className="fixed inset-0 bg-black opacity-50 z-30 md:hidden" onClick={toggleMenu} data-id="element-55" />}
    </div>;
};